import styles from "../DeliveryHighlights/DeliveryHighlights.module.scss";
import { ListWithIcon } from "../ListWithIcon";
import { FREE_CLICK_AND_COLLECT_THRESHOLD } from "@/constants/constants";

export type ClickAndCollectMessageProps = {
  isClickAndCollectAvailable: boolean;
  isOverClickAndCollectThreshold: boolean;
  isDeliveryAndGuaranteeUpdatesEnabled: boolean;
};

export const ClickAndCollect = ({
  isClickAndCollectAvailable,
  isOverClickAndCollectThreshold,
  isDeliveryAndGuaranteeUpdatesEnabled,
}: ClickAndCollectMessageProps) => {
  if (!isClickAndCollectAvailable) {
    return (
      <ListWithIcon
        textMessage="Click & collect not available for this item"
        cssClasses={styles.deliveryMessage}
        dataTestId="product:delivery-message:click-and-collect"
        iconType="info"
      />
    );
  }

  const textMessage = isDeliveryAndGuaranteeUpdatesEnabled
    ? `Free Click & Collect ${isOverClickAndCollectThreshold ? "" : ` over £${FREE_CLICK_AND_COLLECT_THRESHOLD}, otherwise £2.95`}`
    : `Free click & collect ${isOverClickAndCollectThreshold ? "" : ` over £${FREE_CLICK_AND_COLLECT_THRESHOLD}`}`;

  return (
    <ListWithIcon
      textMessage={textMessage}
      cssClasses={styles.deliveryMessage}
      dataTestId="product:delivery-message:click-and-collect"
      iconType="shop"
    />
  );
};
